import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
  getDoc,
  setDoc,
} from "firebase/firestore";

import { db, auth } from "../firebase/config";

// ==========================================
// ATTENDANCE COLLECTION
// ==========================================

const getAttendanceCollection = () => {
  const uid = auth.currentUser?.uid;

  if (!uid) {
    throw new Error("User not authenticated");
  }

  return collection(db, "gyms", uid, "attendance");
};

// ==========================================
// MARK ATTENDANCE
// ==========================================
export const markAttendance = async (attendanceData) => {
  const uid = auth.currentUser?.uid;

  if (!uid) {
    throw new Error("User not authenticated");
  }

  if (!attendanceData.memberId) {
    throw new Error("Member ID is required.");
  }

  if (!attendanceData.memberName) {
    throw new Error("Member name is required.");
  }

  // ==========================================
  // TODAY'S DATE
  // ==========================================

  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");

  const day = String(now.getDate()).padStart(2, "0");

  const today = `${year}-${month}-${day}`;

  // ==========================================
  // UNIQUE DAILY ATTENDANCE ID
  // ==========================================

  const attendanceId = `${attendanceData.memberId}_${today}`;

  const attendanceRef = doc(db, "gyms", uid, "attendance", attendanceId);

  // ==========================================
  // CHECK EXISTING ATTENDANCE
  // ==========================================

  const existingAttendance = await getDoc(attendanceRef);

  if (existingAttendance.exists()) {
    return {
      alreadyMarked: true,
      attendanceId,
      message: `${attendanceData.memberName}'s attendance is already marked for today.`,
    };
  }

  // ==========================================
  // CREATE ATTENDANCE
  // ==========================================

  await setDoc(attendanceRef, {
    memberId: attendanceData.memberId,
    memberName: attendanceData.memberName,
    date: today,
    status: attendanceData.status || "Present",
    createdAt: new Date().toISOString(),
  });

  return {
    alreadyMarked: false,
    attendanceId,
    message: `${attendanceData.memberName}'s attendance marked successfully.`,
  };
};

// ==========================================
// GET ATTENDANCE
// ==========================================

export const getAttendance = async () => {
  const attendanceRef = getAttendanceCollection();

  const snapshot = await getDocs(attendanceRef);

  return snapshot.docs.map((attendanceDoc) => ({
    id: attendanceDoc.id,
    ...attendanceDoc.data(),
  }));
};

// ==========================================
// DELETE ATTENDANCE
// ==========================================

export const deleteAttendance = async (id) => {
  const uid = auth.currentUser?.uid;

  if (!uid) {
    throw new Error("User not authenticated");
  }

  if (!id) {
    throw new Error("Attendance ID is required.");
  }

  const attendanceRef = doc(db, "gyms", uid, "attendance", id);

  await deleteDoc(attendanceRef);
};

// ==========================================
// UPDATE ATTENDANCE STATUS
// ==========================================

export const updateAttendanceStatus = async (id, status) => {
  const uid = auth.currentUser?.uid;

  if (!uid) {
    throw new Error("User not authenticated");
  }

  if (!id) {
    throw new Error("Attendance ID is required.");
  }

  if (!status) {
    throw new Error("Attendance status is required.");
  }

  const attendanceRef = doc(db, "gyms", uid, "attendance", id);

  await updateDoc(attendanceRef, {
    status,
  });
};
